import { FieldName } from '../model';

const STATE = 'state';
export const wrapFieldName = (name: FieldName) => `${STATE}.${name}`;
export const unwrapFieldName = (name: string): FieldName => name.substring(0, STATE.length + 1) as FieldName;
